import React from 'react';
import { Box, Container, Grid, Typography, Button } from '@mui/material';

function Simulation() {
    return (
        <Box
            id="simulation"
            sx={{
                width: '100%',
                backgroundColor: '#141414',
                pt: 3,
                pb: 6,
            }}
        >
            <Container maxWidth="lg">
                <Grid container alignItems="center" spacing={4}>
                    {/* Content Section */}
                    <Grid item xs={12} sm={6}>
                        <Box sx={{ color: 'white', textAlign: 'left' }}>
                            {/* Subtitle */}
                            <Typography
                                variant="subtitle1"
                                sx={{
                                    color: '#1e88e5', // Blue color for subtitle
                                    fontWeight: 'bold',
                                    mb: 1,
                                }}
                            >
                                Assess Cybersecurity Readiness
                            </Typography>

                            {/* Heading */}
                            <Typography
                                variant="h2"
                                sx={{
                                    fontSize: '32px',
                                    fontWeight: '600',
                                    mb: 2,
                                }}
                            >
                                AI-Powered Phishing Simulation
                            </Typography>

                            {/* Paragraph */}
                            <Typography
                                variant="body1"
                                sx={{
                                    color: 'rgba(255, 255, 255, 0.85)',
                                    mb: 2,
                                }}
                            >
                                Simulate real-world phishing attacks and empower your organization to identify threats, train users, and minimize security risks with PhishIntel.
                            </Typography>
                            <Typography
                                variant="body1"
                                sx={{
                                    color: 'rgba(255, 255, 255, 0.85)',
                                    mb: 4,
                                }}
                            >
                                PhishIntel is an open-source phishing simulation tool designed to enhance cybersecurity awareness. Built by CloudSec Network, it empowers organizations to mitigate risks through realistic phishing campaigns.
                            </Typography>

                            {/* Button */}
                            <Button
                                variant="contained"
                                color="primary"
                                size="large"
                                href="https://phishintel.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{
                                    fontWeight: 'bold',
                                }}
                            >
                                Learn More About PhishIntel
                            </Button>
                        </Box>
                    </Grid>

                    {/* Image Section */}
                    <Grid item xs={12} sm={6}>
                        <Box
                            component="img"
                            src="/img/phishintel-dashboard.jpeg"
                            alt="PhishIntel Dashboard"
                            sx={{
                                width: '100%',
                                borderRadius: 2,
                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                            }}
                        />
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
}

export default Simulation;
